import React from 'react';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import { usePerformanceGrid } from '../../Hooks/Features/TalentMatrix/usePerformanceGrid';
import { Tooltip } from 'primereact/tooltip';


const PerformanceGrid = ({ precisionReport, setPrecisionReport, rowData, loader }) => {

    const { columns, tableRows, tooltip } = usePerformanceGrid({ precisionReport, setPrecisionReport, rowData });

    return (
        <div className="shadow-sm border rounded" >
            <div className='d-flex justify-content-between p-2'>
                <div className="fw-bold text-uppercase">Lead Performance Matrix</div>
                <div className="d-flex gap-2 flex-wrap" style={{ fontSize: '11px' }}>
                    <div className='d-flex align-items-center gap-2 fw-semibold'><div style={{ width: "10px", height: "10px", backgroundColor: '#047857', border: "1px solid #166534" }}></div>Excellent (≥ 9.0)</div>
                    <div className='d-flex align-items-center gap-2 fw-semibold'><div style={{ width: "10px", height: "10px", backgroundColor: '#ccffde', border: "1px solid #166534" }}></div>Good (7.5-8.9)</div>
                    <div className='d-flex align-items-center gap-2 fw-semibold'><div style={{ width: "10px", height: "10px", backgroundColor: '#fef3c7', border: "1px solid #d4a184" }}></div>Average (6.0-4.5)</div>
                    <div className='d-flex align-items-center gap-2 fw-semibold'><div style={{ width: "10px", height: "10px", backgroundColor: '#ffedd5b9', border: "1px solid #a56a47" }}></div>Below Avg (4.5-5.9)</div>
                    <div className='d-flex align-items-center gap-2 fw-semibold'><div style={{ width: "10px", height: "10px", backgroundColor: '#fee2e2', border: "1px solid #c67878" }}></div>Critical (&lt; 4.5)</div>
                </div>
            </div>
            <div className='w100' style={{ overflow: "auto" }}>
                <CommonGrid
                    columns={columns}
                    data={[{ title: "", id: "all", children: tableRows }]}
                    expandAll={true}
                    headerHeight={55}
                    loader={loader}
                />
            </div>
            <Tooltip
                target=".precision-summary"
                position="top"
                // mouseTrack={true}
                className="project-glance-tooltip w15"
            >
                <div className='d-flex justify-content-between align-items-center mt-1 pb-2' style={{ borderBottom: "1px dashed lightgrey" }}>
                    <div className='fw-bold text-secondary"' style={{ fontSize: "0.9rem" }}>{tooltip?.group_key}</div>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-1 pb-2 fw-bold'>
                    <div className="text-secondary">Top Performer:</div>
                    <div className='text-success'>{tooltip?.top_performer_name}</div>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-1 pb-2  fw-bold'>
                    <div className="text-secondary">Attention Required:</div>
                    <div className='text-danger'>{tooltip?.lower_performer_name}</div>
                </div>
            </Tooltip>
        </div>
    );
};

export default PerformanceGrid;